// @ts-ignore
import Chat from "url:assets/images/illustrations/Chat.png"

// @ts-ignore
import Chairs from "url:assets/images/illustrations/chairs.png"

// @ts-ignore
import Paperwork from "url:assets/images/illustrations/Paperwork.png"

// @ts-ignore
import ProudLean from "url:assets/images/illustrations/Proud lean.png"

// @ts-ignore
import Key1 from "url:assets/images/illustrations/Key 1.png"

// @ts-ignore
import Key2 from "url:assets/images/illustrations/Key 2.png"

// @ts-ignore
import Boxes from "url:assets/images/illustrations/Boxes.png"

// @ts-ignore
import Boxes1 from "url:assets/images/illustrations/Boxes1.png"

// @ts-ignore
import Paperwork2 from "url:assets/images/illustrations/Paperwork 2.png"

// @ts-ignore
import MagicCarpet from "url:assets/images/illustrations/Magic carpet.png"

// @ts-ignore
import Bike from "url:assets/images/illustrations/Bike.png"

// @ts-ignore
import CoffeeSatDown from "url:assets/images/illustrations/Coffee sat down.png"

// @ts-ignore
import StepUp2 from "url:assets/images/illustrations/Step up 2.png"

// @ts-ignore
import StepUp3 from "url:assets/images/illustrations/Step up 3.png"

// @ts-ignore
import Kids from "url:assets/images/illustrations/Kids.png"

// @ts-ignore
import Mirror from "url:assets/images/illustrations/Mirror.png"

// @ts-ignore
import Desk from "url:assets/images/illustrations/Desk.png"

// @ts-ignore
import Guitar from "url:assets/images/illustrations/Guitar.png"

// @ts-ignore
import PaperworkNoShadow from "url:assets/images/illustrations/Paperwork-no-shadow.png"

export {
  Chat,
  Chairs,
  Paperwork,
  ProudLean,
  Key1,
  Boxes,
  Boxes1,
  Paperwork2,
  MagicCarpet,
  Bike,
  CoffeeSatDown,
  Key2,
  StepUp2,
  StepUp3,
  Kids,
  Mirror,
  Desk,
  Guitar,
  PaperworkNoShadow,
}
